const BASE_URL = "https://apis.mygodowns.com/api/";
// const BASE_URL = 'http://localhost:8000/api/';

export const API_URL = {
  CATEGORY_LIST: `${BASE_URL}category`,
  CATEGORY_GET: `${BASE_URL}category/show`,
  CATEGORY_SAVE: `${BASE_URL}category/store`,
  CATEGORY_UPDATE: `${BASE_URL}category/update`,
  CATEGORY_DELETE: `${BASE_URL}category/delete`,
  CATEGORY_SEQUENCE: `${BASE_URL}category/sequence`,
  CATEGORY_UPDATE_STATUS: `${BASE_URL}category/hide-show`,

  SPECS_LIST: `${BASE_URL}specs`,
  SPECS_GET: `${BASE_URL}specs/show`,
  SPECS_SAVE: `${BASE_URL}specs/store`,
  SPECS_UPDATE: `${BASE_URL}specs/update`,
  SPECS_DELETE: `${BASE_URL}specs/delete`,

  SUB_CATEGORY_LIST: `${BASE_URL}sub-category`,
  SUB_CATEGORY_GET: `${BASE_URL}sub-category/show`,
  SUB_CATEGORY_SAVE: `${BASE_URL}sub-category/store`,
  SUB_CATEGORY_UPDATE: `${BASE_URL}sub-category/update`,
  SUB_CATEGORY_DELETE: `${BASE_URL}sub-category/delete`,
  ADMIN_SUB_CATEGORY_BY_CATEGORY: `${BASE_URL}category/sub-category`,

  COMPANY_LIST: `${BASE_URL}company`,
  COMPANY_GET: `${BASE_URL}company/show`,
  COMPANY_SAVE: `${BASE_URL}company/store`,
  COMPANY_UPDATE: `${BASE_URL}company/update`,
  COMPANY_DELETE: `${BASE_URL}company/delete`,

  VEHICLE_CATEGORY_LIST: `${BASE_URL}vehicle-category`,
  VEHICLE_CATEGORY_GET: `${BASE_URL}vehicle-category/show`,
  VEHICLE_CATEGORY_SAVE: `${BASE_URL}vehicle-category/store`,
  VEHICLE_CATEGORY_UPDATE: `${BASE_URL}vehicle-category/update`,
  VEHICLE_CATEGORY_DELETE: `${BASE_URL}vehicle-category/delete`,

  VEHICLE_LIST: `${BASE_URL}vehicles`,
  VEHICLE_GET: `${BASE_URL}vehicles/show`,
  VEHICLE_SAVE: `${BASE_URL}vehicles/store`,
  VEHICLE_UPDATE: `${BASE_URL}vehicles/update`,
  VEHICLE_DELETE: `${BASE_URL}vehicles/delete`,

  WORKER_CATEGORY_LIST: `${BASE_URL}worker-category`,
  WORKER_CATEGORY_GET: `${BASE_URL}worker-category/show`,
  WORKER_CATEGORY_SAVE: `${BASE_URL}worker-category/store`,
  WORKER_CATEGORY_UPDATE: `${BASE_URL}worker-category/update`,
  WORKER_CATEGORY_DELETE: `${BASE_URL}worker-category/delete`,

  WORKER_LIST: `${BASE_URL}workers`,
  WORKER_GET: `${BASE_URL}workers/show`,
  WORKER_SAVE: `${BASE_URL}workers/store`,
  WORKER_UPDATE: `${BASE_URL}workers/update`,
  WORKER_DELETE: `${BASE_URL}workers/delete`,

  GRADE_LIST: `${BASE_URL}grade`,
  GRADE_GET: `${BASE_URL}grade/show`,
  GRADE_SAVE: `${BASE_URL}grade/store`,
  GRADE_UPDATE: `${BASE_URL}grade/update`,
  GRADE_DELETE: `${BASE_URL}grade/delete`,

  TESTIMONIAL_LIST: `${BASE_URL}testimonial`,
  TESTIMONIAL_GET: `${BASE_URL}testimonial/show`,
  TESTIMONIAL_SAVE: `${BASE_URL}testimonial/store`,
  TESTIMONIAL_UPDATE: `${BASE_URL}testimonial/update`,
  TESTIMONIAL_DELETE: `${BASE_URL}testimonial/delete`,

  CITY_LIST: `${BASE_URL}city`,
  CITY_GET: `${BASE_URL}city/show`,
  CITY_SAVE: `${BASE_URL}city/store`,
  CITY_UPDATE: `${BASE_URL}city/update`,
  CITY_DELETE: `${BASE_URL}city/delete`,

  COUNTRY_LIST: `${BASE_URL}country`,
  COUNTRY_GET: `${BASE_URL}country/show`,
  COUNTRY_SAVE: `${BASE_URL}country/store`,
  COUNTRY_UPDATE: `${BASE_URL}country/update`,
  COUNTRY_DELETE: `${BASE_URL}country/delete`,

  STATE_LIST: `${BASE_URL}state`,
  STATE_GET: `${BASE_URL}state/show`,
  STATE_SAVE: `${BASE_URL}state/store`,
  STATE_UPDATE: `${BASE_URL}state/update`,
  STATE_DELETE: `${BASE_URL}state/delete`,

  TRANSPORT_LIST: `${BASE_URL}transport`,
  TRANSPORT_GET: `${BASE_URL}transport/show`,
  TRANSPORT_SAVE: `${BASE_URL}transport/store`,
  TRANSPORT_UPDATE: `${BASE_URL}transport/update`,
  TRANSPORT_DELETE: `${BASE_URL}transport/delete`,

  PARTY_LIST: `${BASE_URL}party`,
  PARTY_GET: `${BASE_URL}party/show`,
  PARTY_SAVE: `${BASE_URL}party/store`,
  PARTY_UPDATE: `${BASE_URL}party/update`,
  PARTY_DELETE: `${BASE_URL}party/delete`,

  // SUPPLIERS_LIST: `${BASE_URL}supplier`,
  // SUPPLIERS_GET: `${BASE_URL}supplier/show`,
  // SUPPLIERS_SAVE: `${BASE_URL}supplier/store`,
  // SUPPLIERS_UPDATE: `${BASE_URL}supplier/update`,
  // SUPPLIERS_DELETE: `${BASE_URL}supplier/delete`,

  SIZE_LIST: `${BASE_URL}size`,
  SIZE_GET: `${BASE_URL}size/show`,
  SIZE_SAVE: `${BASE_URL}size/store`,
  SIZE_UPDATE: `${BASE_URL}size/update`,
  SIZE_DELETE: `${BASE_URL}size/delete`,

  NEWS_LIST: `${BASE_URL}news`,
  NEWS_GET: `${BASE_URL}news/show`,
  NEWS_SAVE: `${BASE_URL}news/store`,
  NEWS_UPDATE: `${BASE_URL}news/update`,
  NEWS_DELETE: `${BASE_URL}news/delete`,

  SLIDER_LIST: `${BASE_URL}slider`,
  SLIDER_GET: `${BASE_URL}slider/show`,
  SLIDER_SAVE: `${BASE_URL}slider/store`,
  SLIDER_UPDATE: `${BASE_URL}slider/update`,
  SLIDER_DELETE: `${BASE_URL}slider/delete`,

  POST_LIST: `${BASE_URL}posts`,
  POST_GET: `${BASE_URL}posts/show`,
  POST_SAVE: `${BASE_URL}posts/store`,
  POST_UPDATE: `${BASE_URL}posts/update`,
  POST_DELETE: `${BASE_URL}posts/delete`,

  CATALOGUE_LIST: `${BASE_URL}catalogue`,
  CATALOGUE_GET: `${BASE_URL}catalogue/show`,
  CATALOGUE_SAVE: `${BASE_URL}catalogue/store`,
  CATALOGUE_UPDATE: `${BASE_URL}catalogue/update`,
  CATALOGUE_DELETE: `${BASE_URL}catalogue/delete`,

  SERIES_LIST: `${BASE_URL}series`,
  SERIES_GET: `${BASE_URL}series/show`,
  SERIES_SAVE: `${BASE_URL}series/store`,
  SERIES_UPDATE: `${BASE_URL}series/update`,
  SERIES_DELETE: `${BASE_URL}series/delete`,
  SERIES_IMAGES: `${BASE_URL}series/images`,
  SERIES_SAVE_IMAGE: `${BASE_URL}series/save-image`,
  SERIES_DELETE_IMAGE: `${BASE_URL}series/delete-image`,
  SERIES_PAGE_NUMBER: `${BASE_URL}series/order-image`,

  PRODUCT_LIST: `${BASE_URL}product`,
  PRODUCT_GET: `${BASE_URL}product/show`,
  PRODUCT_LATEST: `${BASE_URL}product/latest`,
  PRODUCT_SAVE: `${BASE_URL}product/store`,
  PRODUCT_UPDATE: `${BASE_URL}product/update`,
  PRODUCT_DELETE: `${BASE_URL}product/delete`,
  PRODUCT_WITH_SUB_LIST: `${BASE_URL}product/lists`,
  PRODUCT_ONLY: `${BASE_URL}product/only`,
  PRODUCT_SUPPLIER: `${BASE_URL}product/supplier`,
  PRODUCT_ADD_IMAGE: `${BASE_URL}product/add-image`,
  PRODUCT_DELETE_IMAGE: `${BASE_URL}product/delete-image`,
  PRODUCT_IN_STOCK: `${BASE_URL}product/in-stock`,
  PRODUCT_IMAGES: `${BASE_URL}product/images`,
  PRODUCT_UPDATE_STATUS: `${BASE_URL}product/hide-show`,

  SUB_PRODUCT_LIST: `${BASE_URL}sub-product`,
  SUB_PRODUCT_GET: `${BASE_URL}sub-product/show`,
  SUB_PRODUCT_SAVE: `${BASE_URL}sub-product/store`,
  SUB_CATEGORY_SEQUENCE: `${BASE_URL}sub-category/sequence`,
  SUB_CATEGORY_UPDATE_STATUS: `${BASE_URL}sub-category/hide-show`,
  SUB_PRODUCT_UPDATE: `${BASE_URL}sub-product/update`,
  SUB_PRODUCT_DELETE: `${BASE_URL}sub-product/delete`,

  BANKS_LIST: `${BASE_URL}banks`,
  BANKS_GET: `${BASE_URL}banks/show`,
  BANKS_SAVE: `${BASE_URL}banks/store`,
  BANKS_UPDATE: `${BASE_URL}banks/update`,
  BANKS_DELETE: `${BASE_URL}banks/delete`,

  SALES_RETURN_LIST: `${BASE_URL}sales-return`,
  SALES_RETURN_LATEST: `${BASE_URL}sales-return/latest`,
  SALES_RETURN_SAVE: `${BASE_URL}sales-return/store`,
  SALES_RETURN_SHOW: `${BASE_URL}sales-return/show`,
  SALES_RETURN_DELETE: `${BASE_URL}sales-return/delete`,

  CASH_SALES_LIST: `${BASE_URL}sales/cash`,
  CASH_SALES_GET: `${BASE_URL}sales/cash/show`,
  CASH_SALES_SAVE: `${BASE_URL}sales/cash/store`,
  CASH_SALES_UPDATE: `${BASE_URL}sales/cash/update`,
  CASH_SALES_DELETE: `${BASE_URL}sales/cash/delete`,

  SAVE_USER: `${BASE_URL}save-user`,
  SETTING_PASSWORD: `${BASE_URL}password-update`,
  LOGIN_URL: `${BASE_URL}login`,
  STATES_LIST: `${BASE_URL}states`,
  LOGIN_USER: `${BASE_URL}me`,
  SETTING_SHOW: `${BASE_URL}settings/show`,
  SETTING_SAVE: `${BASE_URL}settings/store`,
  NOTIFICATION: `${BASE_URL}settings/send-notification`,

  DASHBOARD_DATA: `${BASE_URL}dashboard/counts`,
  PENDING_SUMMARY: `${BASE_URL}dashboard/pending-summary`,
  SALES_SUMMARY: `${BASE_URL}dashboard/sales-summary`,
  PURCHASE_SUMMARY: `${BASE_URL}dashboard/purchase-summary`,
  SALES_RETURN_SUMMARY: `${BASE_URL}dashboard/sales-return-summary`,

  INVOICE_LIST: `${BASE_URL}sales`,
  INVOICE_LATEST: `${BASE_URL}sales/latest`,
  INVOICE_GET: `${BASE_URL}sales/show`,
  INVOICE_SAVE: `${BASE_URL}sales/store`,
  INVOICE_UPDATE: `${BASE_URL}sales/update`,
  INVOICE_DELETE: `${BASE_URL}sales/delete`,

  SALES_PENDING_LIST: `${BASE_URL}sales`,
  SALES_PENDING_LATEST: `${BASE_URL}sales/latest`,
  SALES_PENDING_GET: `${BASE_URL}sales/show`,
  SALES_PENDING_SAVE: `${BASE_URL}sales/store`,
  SALES_PENDING_UPDATE: `${BASE_URL}sales/update`,
  SALES_PENDING_DELETE: `${BASE_URL}sales/delete`,

  PERFORMA_LIST: `${BASE_URL}sales/performa`,
  PERFORMA_LATEST: `${BASE_URL}sales/performa/latest`,
  PERFORMA_GET: `${BASE_URL}sales/performa/show`,
  PERFORMA_SAVE: `${BASE_URL}sales/performa/store`,
  PERFORMA_UPDATE: `${BASE_URL}sales/performa/update`,
  PERFORMA_DELETE: `${BASE_URL}sales/performa/delete`,

  SAMPLES_LIST: `${BASE_URL}samples`,
  SAMPLES_GET: `${BASE_URL}samples/show`,
  SAMPLES_SAVE: `${BASE_URL}samples/store`,
  SAMPLES_UPDATE: `${BASE_URL}samples/store`,
  SAMPLES_DELETE: `${BASE_URL}samples/delete`,

  PURCHASE_LIST: `${BASE_URL}purchase`,
  PURCHASE_GET: `${BASE_URL}purchase/show`,
  PURCHASE_SAVE: `${BASE_URL}purchase/store`,
  PURCHASE_UPDATE: `${BASE_URL}purchase/update`,
  PURCHASE_DELETE: `${BASE_URL}purchase/delete`,

  PURCHASE_RETURN_LIST: `${BASE_URL}purchase-return`,
  PURCHASE_RETURN_LATEST: `${BASE_URL}purchase-return/latest`,
  PURCHASE_RETURN_GET: `${BASE_URL}purchase-return/show`,
  PURCHASE_RETURN_SAVE: `${BASE_URL}purchase-return/store`,
  PURCHASE_RETURN_UPDATE: `${BASE_URL}purchase-return/update`,
  PURCHASE_RETURN_DELETE: `${BASE_URL}purchase-return/delete`,

  PURCHASE_ORDER_LIST: `${BASE_URL}purchase-order`,
  PURCHASE_ORDER_LATEST: `${BASE_URL}purchase-order/latest`,
  PURCHASE_ORDER_GET: `${BASE_URL}purchase-order/show`,
  PURCHASE_ORDER_SAVE: `${BASE_URL}purchase-order/store`,
  PURCHASE_ORDER_UPDATE: `${BASE_URL}purchase-order/update`,
  PURCHASE_ORDER_DELETE: `${BASE_URL}purchase-order/delete`,

  PAYMENT_LIST: `${BASE_URL}payments`,
  PAYMENT_GET: `${BASE_URL}payments/show`,
  PAYMENT_SAVE: `${BASE_URL}payments/store`,
  PAYMENT_UPDATE: `${BASE_URL}payments/update`,
  PAYMENT_DELETE: `${BASE_URL}payments/delete`,

  TERMS_LIST: `${BASE_URL}terms`,
  TERMS_GET: `${BASE_URL}terms/show`,
  TERMS_SAVE: `${BASE_URL}terms/store`,
  TERMS_UPDATE: `${BASE_URL}terms/update`,
  TERMS_DELETE: `${BASE_URL}terms/delete`,

  FAQS_LIST: `${BASE_URL}faqs`,
  FAQS_GET: `${BASE_URL}faqs/show`,
  FAQS_SAVE: `${BASE_URL}faqs/store`,
  FAQS_UPDATE: `${BASE_URL}faqs/update`,
  FAQS_DELETE: `${BASE_URL}faqs/delete`,

  CONTACT_PERSON_LIST: `${BASE_URL}contact-person`,
  CONTACT_PERSON_GET: `${BASE_URL}contact-person/show`,
  CONTACT_PERSON_SAVE: `${BASE_URL}contact-person/store`,
  CONTACT_PERSON_UPDATE: `${BASE_URL}contact-person/update`,
  CONTACT_PERSON_DELETE: `${BASE_URL}contact-person/delete`,

  INQUIRY_LIST: `${BASE_URL}settings/inquiries`,
  INQUIRY_DELETE: `${BASE_URL}settings/inquiries/delete`,

  HELPLINE_LIST: `${BASE_URL}helpline`,
  HELPLINE_GET: `${BASE_URL}helpline/show`,
  HELPLINE_SAVE: `${BASE_URL}helpline/store`,
  HELPLINE_UPDATE: `${BASE_URL}helpline/update`,
  HELPLINE_DELETE: `${BASE_URL}helpline/delete`,

  LEDGER_LIST: `${BASE_URL}ledgers`,
  OUTSTANDING: `${BASE_URL}ledgers/outstanding`,
  PARTY_PAYMENT_LEDGER: `${BASE_URL}party-payment-ledger`,

  DEALER_USERS_LIST: `${BASE_URL}dealer-users`,
  DEALER_USERS_STORE: `${BASE_URL}dealer-users/store`,
  DEALER_USERS_SEARCH: `${BASE_URL}dealer-users/search`,
  DEALER_USERS_SHOW: `${BASE_URL}dealer-users/show`,
  DEALER_USERS_UPDATE: `${BASE_URL}dealer-users/update`,
  DEALER_USERS_DELETE: `${BASE_URL}dealer-users/delete`,
  DEALER_USERS_APPROVE: `${BASE_URL}dealer-users/approve`,

  USERS_SEARCH: `${BASE_URL}users/search`,
  USERS_DEALERS: `${BASE_URL}users/dealers`,
  USERS_DIRECT: `${BASE_URL}users/direct-user`,
  USERS_ADD_DIRECT: `${BASE_URL}users/add-direct-user`,
  USERS_REMOVE_DIRECT: `${BASE_URL}users/remove-direct-user`,
  USERS_WHO_CAN_SEE: `${BASE_URL}users/show-who-can-see`,
  USERS_ADD_WHO_CAN_SEE: `${BASE_URL}users/add-who-can-see`,
  USERS_REMOVE_WHO_CAN_SEE: `${BASE_URL}users/remove-who-can-see`,
  USERS_UPDATE_WHO_CAN_SEE: `${BASE_URL}users/update-who-can-see`,
  USERS_APPROVE: `${BASE_URL}users/approve`,
  USERS_ROLES: `${BASE_URL}users/roles`,
  USERS_LIST: `${BASE_URL}users`,
  USERS_GET: `${BASE_URL}users/show`,
  USERS_SAVE: `${BASE_URL}users/store`,
  USERS_UPDATE: `${BASE_URL}users/update`,
  USERS_DELETE: `${BASE_URL}users/delete`,
  USERS_ADD_PLAN: `${BASE_URL}users/add-plan`,
  USERS_VIEW_PLAN: `${BASE_URL}users/view-plan`,
  USERS_DELETE_PLAN: `${BASE_URL}users/delete-plan`,

  PLAN_LIST: `${BASE_URL}plans`,
  PLAN_GET: `${BASE_URL}plans/show`,
  PLAN_SAVE: `${BASE_URL}plans/store`,
  PLAN_UPDATE: `${BASE_URL}plans/update`,
  PLAN_DELETE: `${BASE_URL}plans/delete`,
};
